import { Module, MutationTree } from 'vuex';
import { RootState } from '../../types';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { OnboardingState } from './types';

const namespaced = true;

const state: OnboardingState = {
  oneSuggestedNumber: '',
  suggestedNumbers: [],
  numberSearchError: '',
  batchIndex: 0,
  selectedNumber: '',
  phoneNumber: {
    id: '',
    number: '',
    name: '',
    callFlow: {},
    textFlow: {}
  },
  onboardingStep: 0
};

const onboarding: Module<OnboardingState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations: mutations as MutationTree<OnboardingState>
};

export default onboarding;
